import PublisherDetailPage, { getServerSideProps } from './index';

export { getServerSideProps };
export default PublisherDetailPage;
